<script>
import {
  friendListComputed,
  friendListMethods,
} from '@state/helpers/friend-list'
import SearchPayload from '@utils/searchPayload'
import { ObjectHelper, addParamsToLocation } from '@utils/helpers'
import tableFields from './tableFields'
import fieldsBoxCard from './fieldsBoxCard'

export default {
  page: {
    title: 'Friend List',
    meta: [{ name: 'description', content: 'The Friend List page.' }],
  },
  data() {
    return {
      items: {},
      searchBody: new SearchPayload.Builder(),
      fields: tableFields,
      filtered: false,
      fieldsBoxCard: fieldsBoxCard,
      componentKey: 0,
    }
  },
  computed: {
    ...friendListComputed,
    friendListData() {
      return (
        this.getFriendList?.list?.map((item) => {
          return item
        }) || []
      )
    },
    paginationComputed() {
      let paginations = {}
      if (this.getFriendList) {
        paginations = ObjectHelper.removePropertyByKey('list')(
          this.getFriendList
        )
      }
      return paginations
    },
  },
  watch: {
    searchBody() {
      addParamsToLocation(this.$route, this.searchBody)
      this.componentKey++
    },
  },
  created() {
    const filter = this.$route.query
    filter.page_no = parseInt(filter.page_no, 10)
    filter.lines = parseInt(filter.lines, 10)
    for (const key in filter) {
      if (key !== 'page_no' && key !== 'lines') {
        if (filter[key] !== '' && filter[key] !== undefined) {
          this.searchBody = filter
          this.filtered = true
        }
      }
    }
    if (filter.page_no > 1) {
      this.searchBody = filter
    }
    this.handleSearchFriend()
  },
  methods: {
    ...friendListMethods,
    handlePagination(body) {
      this.searchBody = { ...this.searchBody, ...body }
      this.handleSearchFriend()
    },
    handleSorter(key) {
      this.searchBody = { ...this.searchBody, order_by: key }
      this.handleSearchFriend()
    },
    handleFilter(params, reset = false) {
      this.searchBody = { ...this.searchBody, ...params }
      this.handleSearchFriend()
      this.filtered = !reset
    },
    handleSearchFriend() {
      this.fetchingFriendList(this.searchBody)
    },
  },
}
</script>

<template>
  <div>
    <BaseFilterBoxCard
      :key="componentKey"
      :filter-value="searchBody"
      :fields="fieldsBoxCard"
      @filter="(p, r) => handleFilter(p, r)"
    />
    <BasePagination
      :paginations="paginationComputed"
      :searching="filtered"
      @activePagination="handlePagination"
    >
    </BasePagination>
    <BaseTable
      striped
      border
      :table-fields="fields"
      :data-tables="friendListData"
      @sorterBy="handleSorter"
    >
    </BaseTable>
  </div>
</template>
